export default __webpack_public_path__ + "static/media/ic_home.ad94459b.svg";